import Footer from '../components/Footer';
import LandingHeader from '../components/LandingHeader';

const TermsOfService = () => {
  const handleSignIn = () => {
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <LandingHeader onSignIn={handleSignIn} />

      {/* Content */}
      <div className="bg-white py-4 sm:py-6 md:py-8">
        <main className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-6 sm:mb-8 md:mb-10">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-3 sm:mb-4 tracking-tight">Terms of Service</h1>
            <p className="text-sm sm:text-base text-gray-600">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          </div>

        <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-6 sm:p-8 md:p-10 space-y-8 sm:space-y-10">
          <section>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 tracking-tight">1. Acceptance of Terms</h2>
            <p className="text-gray-600 leading-relaxed text-base sm:text-lg">
              By accessing and using Inbox Mate ("the Service"), you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to these Terms of Service, please do not use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 tracking-tight">2. Description of Service</h2>
            <p className="text-gray-600 leading-relaxed text-base sm:text-lg mb-4">
              Inbox Mate provides a Gmail management platform that transforms your inbox into a Kanban board with AI-powered email response generation capabilities. The Service includes:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4 text-base sm:text-lg leading-relaxed">
              <li>Email organization and management tools</li>
              <li>Kanban board interface for Gmail</li>
              <li>AI-powered email response generation (Pro plan)</li>
              <li>Custom knowledge base integration (Pro plan)</li>
              <li>Multiple AI personality styles (Pro plan)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 tracking-tight">3. User Accounts</h2>
            <div className="space-y-4 sm:space-y-6">
              <div>
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3">3.1 Account Creation</h3>
                <p className="text-gray-600 leading-relaxed text-base sm:text-lg">
                  You must create an account using Google OAuth to use the Service. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
                </p>
              </div>
              <div>
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3">3.2 Account Responsibilities</h3>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4 text-base sm:text-lg leading-relaxed">
                  <li>You must be at least 13 years old to use the Service</li>
                  <li>You must provide accurate and complete information</li>
                  <li>You are responsible for all content and activity under your account</li>
                  <li>You must notify us immediately of any unauthorized use of your account</li>
                </ul>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 tracking-tight">4. Subscription and Billing</h2>
            <div className="space-y-4 sm:space-y-6">
              <div>
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3">4.1 Free Trial</h3>
                <p className="text-gray-600 leading-relaxed text-base sm:text-lg">
                  We offer a 3-day free trial for new users. No credit card is required to start the trial. After the trial period, you must subscribe to continue using the Service.
                </p>
              </div>
              <div>
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3">4.2 Subscription Plans</h3>
                <p className="text-gray-600 leading-relaxed text-base sm:text-lg mb-3">
                  We offer monthly subscription plans with the following terms:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4 text-base sm:text-lg leading-relaxed">
                  <li>Subscriptions are billed monthly in advance</li>
                  <li>All fees are in U.S. dollars</li>
                  <li>Payment is processed through Stripe</li>
                  <li>Subscription automatically renews unless cancelled</li>
                </ul>
              </div>
              <div>
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3">4.3 Cancellation and Refunds</h3>
                <p className="text-gray-600 leading-relaxed text-base sm:text-lg">
                  You may cancel your subscription at any time. You will retain access to the Service until the end of your current billing period. We offer a 30-day money-back guarantee from the date of your first purchase.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 tracking-tight">5. Acceptable Use</h2>
            <p className="text-gray-600 leading-relaxed text-base sm:text-lg mb-4">You agree not to use the Service to:</p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4 text-base sm:text-lg leading-relaxed">
              <li>Violate any laws or regulations</li>
              <li>Infringe on intellectual property rights of others</li>
              <li>Transmit viruses, malware, or other harmful code</li>
              <li>Harass, abuse, or harm others</li>
              <li>Spam or send unsolicited communications</li>
              <li>Attempt to gain unauthorized access to the Service</li>
              <li>Interfere with or disrupt the Service</li>
              <li>Use the Service for any illegal or unauthorized purpose</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 tracking-tight">6. Intellectual Property</h2>
            <div className="space-y-4 sm:space-y-6">
              <div>
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3">6.1 Service Ownership</h3>
                <p className="text-gray-600 leading-relaxed text-base sm:text-lg">
                  The Service, including all content, features, and functionality, is owned by Inbox Mate and is protected by copyright, trademark, and other intellectual property laws.
                </p>
              </div>
              <div>
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3">6.2 User Content</h3>
                <p className="text-gray-600 leading-relaxed text-base sm:text-lg">
                  You retain ownership of all content you create or upload to the Service, including your knowledge base content. By using the Service, you grant us a limited license to use your content solely to provide the Service to you.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 tracking-tight">7. Third-Party Services</h2>
            <p className="text-gray-600 leading-relaxed text-base sm:text-lg mb-4">
              The Service integrates with third-party services including:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4 text-base sm:text-lg leading-relaxed">
              <li><strong className="text-gray-900">Google Gmail API:</strong> For accessing and managing your emails</li>
              <li><strong className="text-gray-900">OpenAI:</strong> For AI-powered email generation</li>
              <li><strong className="text-gray-900">Stripe:</strong> For payment processing</li>
            </ul>
            <p className="text-gray-600 leading-relaxed text-base sm:text-lg mt-4">
              Your use of these third-party services is subject to their respective terms of service and privacy policies.
            </p>
          </section>

          <section>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 tracking-tight">8. Disclaimer of Warranties</h2>
            <p className="text-gray-600 leading-relaxed text-base sm:text-lg mb-4">
              THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4 text-base sm:text-lg leading-relaxed">
              <li>Warranties of merchantability</li>
              <li>Fitness for a particular purpose</li>
              <li>Non-infringement</li>
              <li>Uninterrupted or error-free operation</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 tracking-tight">9. Limitation of Liability</h2>
            <p className="text-gray-600 leading-relaxed text-base sm:text-lg">
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, INBOX MATE SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES RESULTING FROM YOUR USE OF THE SERVICE.
            </p>
          </section>

          <section>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 tracking-tight">10. Indemnification</h2>
            <p className="text-gray-600 leading-relaxed text-base sm:text-lg">
              You agree to indemnify and hold harmless Inbox Mate from any claims, damages, losses, liabilities, and expenses (including attorneys' fees) arising out of your use of the Service, your violation of these Terms, or your violation of any rights of another.
            </p>
          </section>

          <section>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 tracking-tight">11. Termination</h2>
            <p className="text-gray-600 leading-relaxed text-base sm:text-lg mb-4">
              We reserve the right to suspend or terminate your account and access to the Service at our sole discretion, without notice, for conduct that we believe:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4 text-base sm:text-lg leading-relaxed">
              <li>Violates these Terms of Service</li>
              <li>Is harmful to other users or the Service</li>
              <li>Violates applicable laws or regulations</li>
              <li>Is fraudulent or abusive</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 tracking-tight">12. Changes to Terms</h2>
            <p className="text-gray-600 leading-relaxed text-base sm:text-lg">
              We reserve the right to modify these Terms at any time. We will notify you of any material changes by posting the new Terms on this page and updating the "Last updated" date. Your continued use of the Service after such changes constitutes your acceptance of the new Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 tracking-tight">13. Governing Law</h2>
            <p className="text-gray-600 leading-relaxed text-base sm:text-lg">
              These Terms shall be governed by and construed in accordance with the laws of the United States, without regard to its conflict of law provisions.
            </p>
          </section>

          <section>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 tracking-tight">14. Contact Information</h2>
            <p className="text-gray-600 leading-relaxed text-base sm:text-lg">
              If you have any questions about these Terms of Service, please contact us at:{' '}
              <a href="mailto:support@inboxmate.com" className="text-blue-600 hover:text-blue-800 underline font-medium">
                support@inboxmate.com
              </a>
            </p>
          </section>
        </div>

        {/* Back to top */}
        <div className="mt-8 sm:mt-10 text-center">
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="text-blue-600 hover:text-blue-700 font-medium text-sm sm:text-base"
          >
            Back to top ↑
          </button>
        </div>
        </main>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TermsOfService;
